import { PLANT_CATALOG, PLANT_CATEGORIES } from './data';
import { pickerSpeciesKey } from './plantPicker';
import { normalizeCultivar } from './cultivars';

export const catalogSpecies = value => PLANT_CATALOG.find(p =>
  [p.id, p.scientific_name, ...Object.values(p.name || {})].filter(Boolean).some(name => normalizeCultivar(name) === normalizeCultivar(value)));
export const candidateCommonName = candidate => candidate?.species_common_name ?? candidate?.common_name ?? candidate?.name ?? '';
export const candidateSpeciesKey = candidate => {
  const raw = candidate?.catalog_key || candidate?.species_key || candidateCommonName(candidate);
  return catalogSpecies(raw)?.id || String(raw || '').normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '').slice(0, 64) || 'custom_plant';
};
export const candidateCategory = candidate => catalogSpecies(candidateSpeciesKey(candidate))?.cat ||
  ([...PLANT_CATEGORIES.map(c => c.id).filter(id => id !== 'all'), 'other'].includes(candidate?.category) ? candidate.category : '');

// A manually changed identity must not retain an unrelated AI species, care, variety or confidence.
export function correctCandidateSpecies(candidate, name, category) {
  const entry = catalogSpecies(name);
  const nextKey = entry?.id || candidateSpeciesKey({ species_common_name: name });
  const same = pickerSpeciesKey(candidateSpeciesKey(candidate)) === pickerSpeciesKey(nextKey);
  return {
    species_common_name: name, common_name: name, catalog_key: entry?.id || null, species_key: nextKey,
    category: entry?.cat || category || '',
    ...(!same ? { variety: '', scientific_name: entry?.scientific_name || null, species: null,
      care: null, sun: null, water: null, confidence: null, water_interval_days: null, emoji: entry?.emoji || '🌱' } : {}),
  };
}

export function bedPlantSelection(entry, label, variety = '') {
  return { id: entry.id, name: entry.name, emoji: entry.emoji || '🌿', color: entry.color || '#5a7a4a',
    species: entry.id, category: entry.cat, speciesLabel: label, variety,
    label: variety ? `${label} · ${variety}` : label };
}
export function bedCellSelection(selected, r, c) {
  // Keep catalogue/custom planning IDs; never invent an owned garden-plant ID.
  return { r, c, plant_id: selected.id || selected.label, emoji: selected.emoji,
    label: selected.label || selected.name?.da, color: selected.color || '#5a7a4a',
    ...(selected.species ? { species: selected.species, category: selected.category, variety: selected.variety || '' } : {}) };
}
